import React, { Component } from 'react'
import { AddonName } from '../../apis/addon.api'
import InputText from '../../components/InputText'
import Label from '../../components/Label'

type Labels = Record<AddonName, string | null>
type DefaultValues = Record<AddonName, string | null>

interface Props {
    value: string
    addon: AddonName
    onChange: (name: string, value: string) => void
}

export default class MetaModifyValueInput extends Component<Props> {
  labels: Labels = {
    extendInventoryCreateFormWhenItemEquals: 'Input label',
    extendInventoryCreateFormWithQuantityOnCase: null,
    extendInventoryCreateFormWithActualWeight: 'Input label',
    extendPackTraceCreateFormWithPallet: null,
    changePalletCode: 'Pallet code pattern',
    changeCaseCode: 'Case code pattern',
    extendInventoryCreateFormWhenCategoryNameEquals: 'Input label'
  }

  defaultValues: DefaultValues = {
    extendInventoryCreateFormWhenItemEquals: '',
    extendInventoryCreateFormWithQuantityOnCase: null,
    extendInventoryCreateFormWithActualWeight: 'Actual weight',
    extendPackTraceCreateFormWithPallet: null,
    changePalletCode: 'palletCode-itemCode-julianDatetime',
    changeCaseCode: 'caseCode-palletCode-itemCode-julianDatetime',
    extendInventoryCreateFormWhenCategoryNameEquals: ''
  }

  get label () {
    return this.labels[this.props.addon]
  }

  get defaultValue () {
    return this.defaultValues[this.props.addon] || ''
  }

  availableVariables (variables: string[]) {
    return (
            <div className='flex flex-wrap gap-1 items-baseline'>
                <strong className='text-xs'>Available variables: </strong>
                {
                    variables.map(variable => {
                      return (
                            <Label type='light' size='regular' text={variable} key={variable}/>
                      )
                    })
                }
            </div>
    )
  }

  get infoText () {
    switch (this.props.addon) {
      case 'changeCaseCode': {
        const variables = ['workOrderCode', 'palletCode', 'palletNumber', 'caseCode', 'caseNumber', 'itemCode', 'julianDatetime']
        return this.availableVariables(variables)
      }
      case 'changePalletCode': {
        const variables = ['workOrderCode', 'palletCode', 'palletNumber', 'itemCode', 'julianDatetime']
        return this.availableVariables(variables)
      }
      default:
        return null
    }
  }

  setDefaultValue () {
    const { value, onChange } = this.props
    if (!value) onChange('value', this.defaultValue)
  }

  componentDidMount () {
    this.setDefaultValue()
  }

  componentDidUpdate (prevProps: Props) {
    const currentProps = this.props
    if (currentProps.addon !== prevProps.addon) {
      currentProps.onChange('value', this.defaultValue)
    }
  }

  render () {
    return this.label &&
            <div>
                <InputText
                    name="value"
                    value={this.props.value}
                    label={this.label}
                    onChange={this.props.onChange}/>
                {this.infoText}
            </div>
  }
}
